import { Audited, Medium } from '@ianesthesie-kit/services';
import { GroupedList } from '@/util';
import { SourceType } from '@/modules/surgicalEvent';

export enum MedicalDocumentType {
  ECG = 'ECG',
  CARDIAC_TEST = 'CARDIAC_TEST',
  FACE_PICTURE = 'FACE_PICTURE',
  ULTRASOUND = 'ULTRASOUND',
  BLOODWORK = 'BLOODWORK',
  PRESCRIPTION = 'PRESCRIPTION',
  CHILD_HEALTH_RECORD = 'CHILD_HEALTH_RECORD',
  GENETIC_RESULTS = 'GENETIC_RESULTS',
  ECG_SMARTWATCH = 'ECG_SMARTWATCH',
  PACEMAKER_DEFIBRILLATOR_CARD = 'PACEMAKER_DEFIBRILLATOR_CARD',
  OTHER = 'OTHER', // TODO Remove this
  TOBACCO_PRESCRIPTION = 'TOBACCO_PRESCRIPTION',
  TOBACCO_SPECIALIST_REFERRAL = 'TOBACCO_SPECIALIST_REFERRAL',
  UNDER_NUTRITION_PRESCRIPTION = 'UNDER_NUTRITION_PRESCRIPTION',
  UNDER_NUTRITION_SPECIALIST_REFERRAL = 'UNDER_NUTRITION_SPECIALIST_REFERRAL',
  PREOP_LAB_TEST_PRESCRIPTION = 'PREOP_LAB_TEST_PRESCRIPTION',
  GENERIC_PRESCRIPTION = 'GENERIC_PRESCRIPTION',
  ANEMIA_IRON_INJECTION_PRESCRIPTION = 'ANEMIA_IRON_INJECTION_PRESCRIPTION',
  ANEMIA_EPO_INJECTION_PRESCRIPTION = 'ANEMIA_EPO_INJECTION_PRESCRIPTION',
  ANEMIA_EXPERT_REFERRAL = 'ANEMIA_EXPERT_REFERRAL',
  OSA_SPECIALIST_REFERRAL = 'OSA_SPECIALIST_REFERRAL',
  TEMPLATE_COVER_LETTER = 'TEMPLATE_COVER_LETTER',
  TEMPLATE_PREOP_EVALUATION = 'TEMPLATE_PREOP_EVALUATION',
  TEMPLATE_POSTOP_PAIN_CLINICAL_NOTE = 'TEMPLATE_POSTOP_PAIN_CLINICAL_NOTE',
  CONSENT_FORM = 'CONSENT_FORM',
  OPERATOR_INVOICE = 'OPERATOR_INVOICE',

  // Not uploadable, nor prescription
  INSURANCE_CARD = 'INSURANCE_CARD',
  INSURANCE_CARD_FRONT = 'INSURANCE_CARD_FRONT',
  INSURANCE_CARD_BACK = 'INSURANCE_CARD_BACK',
  INSURANCE_POLICY = 'INSURANCE_POLICY',
  COMPLETE_REPORT = 'COMPLETE_REPORT',

  // Generated custom documents
  CUSTOM_DOCUMENT = 'CUSTOM_DOCUMENT'
}

export const insuranceDocumentTypes = [
  MedicalDocumentType.INSURANCE_CARD,
  MedicalDocumentType.INSURANCE_CARD_FRONT,
  MedicalDocumentType.INSURANCE_CARD_BACK,
  MedicalDocumentType.INSURANCE_POLICY
];

export const uploadableDocumentTypes = [
  MedicalDocumentType.ECG,
  MedicalDocumentType.CARDIAC_TEST,
  MedicalDocumentType.FACE_PICTURE,
  MedicalDocumentType.ULTRASOUND,
  MedicalDocumentType.BLOODWORK,
  MedicalDocumentType.PRESCRIPTION,
  MedicalDocumentType.CHILD_HEALTH_RECORD,
  MedicalDocumentType.GENETIC_RESULTS,
  MedicalDocumentType.ECG_SMARTWATCH,
  MedicalDocumentType.PACEMAKER_DEFIBRILLATOR_CARD,
  MedicalDocumentType.OPERATOR_INVOICE,
  MedicalDocumentType.OTHER
].concat(insuranceDocumentTypes);

export const prescriptionDocumentTypes = [
  MedicalDocumentType.TOBACCO_PRESCRIPTION,
  MedicalDocumentType.TOBACCO_SPECIALIST_REFERRAL,
  MedicalDocumentType.UNDER_NUTRITION_PRESCRIPTION,
  MedicalDocumentType.UNDER_NUTRITION_SPECIALIST_REFERRAL,
  MedicalDocumentType.PREOP_LAB_TEST_PRESCRIPTION,
  MedicalDocumentType.ANEMIA_IRON_INJECTION_PRESCRIPTION,
  MedicalDocumentType.ANEMIA_EPO_INJECTION_PRESCRIPTION,
  MedicalDocumentType.ANEMIA_EXPERT_REFERRAL,
  MedicalDocumentType.OSA_SPECIALIST_REFERRAL,
  MedicalDocumentType.GENERIC_PRESCRIPTION,
  MedicalDocumentType.TEMPLATE_COVER_LETTER,
  MedicalDocumentType.TEMPLATE_PREOP_EVALUATION,
  MedicalDocumentType.TEMPLATE_POSTOP_PAIN_CLINICAL_NOTE
];

export interface MedicalDocument extends Audited {
  media: Medium[];
  type: MedicalDocumentType;
  subType?: string;
  date?: string;
  patientVisible?: boolean;
  pending?: boolean;
  extractionStatus?: 'PENDING' | 'FAILED' | 'COMPLETED' | 'NO_DATA';
  sourceType?: SourceType;
}

export type GroupedMedicalDocuments = GroupedList<
  MedicalDocument,
  MedicalDocumentType
>;
